import { Directive, ElementRef, HostListener } from '@angular/core';
import { LMThemeService } from '@banner/lm-theme.service';
import {LMGlobalPersonalizationService} from '@app/states';

@Directive({
  selector: '[lm-new-theme-hover]'
})
export class LMNewThemeHoverDirective {
  @HostListener('mouseenter') onMouseEnter() {
    this.mouseEnter();
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.mouseLeave();
  }

  constructor(
    private lmThemeService: LMThemeService,
    private elementRef: ElementRef,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService
  ) {}

  private mouseEnter() {
    const newThemes = [ 'theme-new-light', 'theme-new-dark', 'theme-new-contrast'];
    if (newThemes.includes(this.lmThemeService.getCurrentThemeId()) &&
      this.lmThemeService.getCurrentColorId() !== 'default' &&
      this.lmGlobalPersonalizationService.getGlobalPersonalization().applyColorToMenu
    ) {
      this.elementRef.nativeElement.style.backgroundColor = this.lmThemeService.getCurrentColor()?.value;
    }
  }

  private mouseLeave() {
    this.elementRef.nativeElement.style.backgroundColor = '';
  }
}
